/**
 * Generate a random string
 */
export function randomString(stringLength = 7) {
    return Math.random().toString(36).substring(stringLength);
}